import { BrushToolController } from '../controllers/tools/brush-tool.js';
import { ConnectorToolController } from '../controllers/tools/connector-tool.js';
import { CopilotSelectionController } from '../controllers/tools/copilot-tool.js';
import { DefaultToolController } from '../controllers/tools/default-tool.js';
import { EraserToolController } from '../controllers/tools/eraser-tool.js';
import { PresentToolController } from '../controllers/tools/frame-navigator-tool.js';
import { FrameToolController } from '../controllers/tools/frame-tool.js';
import { NoteToolController } from '../controllers/tools/note-tool.js';
import { PanToolController } from '../controllers/tools/pan-tool.js';
import { ShapeToolController } from '../controllers/tools/shape-tool.js';
import { TextToolController } from '../controllers/tools/text-tool.js';
import type { EdgelessRootService } from '../edgeless-root-service.js';
import type { EdgelessToolConstructor } from './tools-manager.js';

export const registerTools = (service: EdgelessRootService) => {
  const tools = [
    DefaultToolController,
    BrushToolController,
    EraserToolController,
    TextToolController,
    ShapeToolController,
    ConnectorToolController,
    NoteToolController,
    FrameToolController,
    PanToolController,
    PresentToolController,
    CopilotSelectionController,
  ] as EdgelessToolConstructor[];

  tools.forEach(tool => {
    service.registerTool(tool);
  });
};
